import { z } from 'zod';

export const PositionSubmittedEventPayloadSchema = z.object({ positionId: z.string().uuid() });

export type PositionSubmittedEventPayload = z.infer<typeof PositionSubmittedEventPayloadSchema>;
